import axios, { AxiosInstance } from "axios";

export function createAxiosInstance(): AxiosInstance {
	return axios.create({
		headers: {
			"x-api-version": "1.0",
			"x-time-zone": Intl.DateTimeFormat().resolvedOptions().timeZone,
		},
	});
}
